var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._b({tag:"component"},'component',_vm.getComponentProps,false),_vm._l(((_vm.columnInfo || {}).children),function(item){return _c('pivot-table-column',{key:item.id,attrs:{"columnInfo":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }